import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="hero-subtitle"
            >
              <h1 className="hero-headline">
                Business Websites, Mobile Apps, and Production Software
              </h1>
              
              <p className="hero-sub-headline">
                Top Most Systems delivers software companies can run — from bilingual business sites to mobile apps and legacy systems already in production.
              </p>
              
              <p>
                We build professional business websites and help organizations rescue struggling mobile apps, convert Android (Java) apps to iOS (Objective-C), and keep legacy codebases stable when they are hard to change or already live.
              </p>
              <p>
                A live web example is <a href="https://www.groupednk.ca/" target="_blank" rel="noopener noreferrer" className="hero-inline-link">Groupe DNK</a>, a bilingual engineering site. On mobile, we focus on RTL and layout issues, production crashes, App Store rejections, and hardening AI-generated or inherited code so it works for real users.
              </p>
              <p>
                Built for teams that need clearly scoped work — without long-term contracts, full rewrites, or guesswork.
              </p>
              
              <div className="hero-buttons">
                <motion.button
                  className="btn btn-primary btn-assessment"
                  onClick={() => scrollToSection('contact')}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                >
                  Get a Quick Assessment
                </motion.button>
              </div>
            </motion.div>
            
            
          </motion.div>
          
          <motion.div
            className="hero-features"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
                         <motion.div 
               className="feature-card"
               whileHover={{ y: -10, scale: 1.05 }}
               transition={{ duration: 0.3 }}
               onClick={() => scrollToSection('web-development')}
               style={{ cursor: 'pointer' }}
             >
               <div className="feature-icon">
                 <i className="fas fa-globe"></i>
               </div>
               <h4>Web Development</h4>
               <p>Business websites — see <strong>Groupe DNK</strong></p>
             </motion.div>
            
                         <motion.div 
               className="feature-card"
               whileHover={{ y: -10, scale: 1.05 }}
               transition={{ duration: 0.3 }}
               onClick={() => scrollToSection('mobile-development')}
               style={{ cursor: 'pointer' }}
             >
               <div className="feature-icon">
                 <i className="fas fa-mobile-alt"></i>
               </div>
               <h4>Mobile Development</h4>
               <p>Four published apps, native iOS and Android delivery</p>
             </motion.div>
            
                         <motion.div 
               className="feature-card"
               whileHover={{ y: -10, scale: 1.05 }}
               transition={{ duration: 0.3, delay: 0.1 }}
               onClick={() => scrollToSection('other-development')}
               style={{ cursor: 'pointer' }}
             >
               <div className="feature-icon">
                 <i className="fas fa-cogs"></i>
               </div>
               <h4>Legacy System Modernization</h4>
               <p>Stabilize and modernize legacy .NET & SQL Server systems</p>
             </motion.div>
            
                         <motion.div 
               className="feature-card"
               whileHover={{ y: -10, scale: 1.05 }}
               transition={{ duration: 0.3, delay: 0.2 }}
               onClick={() => scrollToSection('portfolio')}
               style={{ cursor: 'pointer' }}
             >
               <div className="feature-icon">
                 <i className="fas fa-users"></i>
               </div>
               <h4>Project Delivery</h4>
               <p>Full SDLC, architecture, and technical leadership</p>
             </motion.div>
          </motion.div>
        </div>
      </div>
      
      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        onClick={() => scrollToSection('services')}
      >
        <div className="scroll-arrow"></div>
      </motion.div>
    </section>
  );
};

export default Hero;
